var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import * as React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { format, addMonths } from 'date-fns';
import { useRequest } from '../../hooks/requestHook';
import { exchangeRate as api } from '../../api';
import MaterialTable from '../MaterialTable';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var ExchangeRatesPage = function () {
    var t = useTranslation().t;
    var _a = React.useReducer(exchangeRatesReducer, []), exchangeRates = _a[0], dispatch = _a[1];
    var _b = React.useState(true), loading = _b[0], setLoading = _b[1];
    var getAll = useRequest(api.getAll);
    var set = useRequest(api.set);
    var columns = React.useMemo(function () { return [
        {
            field: 'month',
            defaultSort: 'desc',
            editable: 'never',
        },
        {
            field: 'EUR',
            title: t('pages.exchangeRates.exchangeRateColumnTitle', {
                currency: 'EUR',
            }),
            type: 'numeric',
            align: 'right',
        },
        {
            field: 'JPY',
            title: t('pages.exchangeRates.exchangeRateColumnTitle', {
                currency: 'JPY',
            }),
            type: 'numeric',
            align: 'right',
        },
        {
            field: 'KRW',
            title: t('pages.exchangeRates.exchangeRateColumnTitle', {
                currency: 'KRW',
            }),
            type: 'numeric',
            align: 'right',
        },
        {
            field: 'TWD',
            title: t('pages.exchangeRates.exchangeRateColumnTitle', {
                currency: 'TWD',
            }),
            type: 'numeric',
            align: 'right',
        },
    ]; }, [t]);
    React.useEffect(function () {
        var canceled = false;
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setLoading(true);
                        return [4 /*yield*/, getAll(undefined)];
                    case 1:
                        response = _a.sent();
                        if (!response || canceled)
                            return [2 /*return*/];
                        setLoading(false);
                        dispatch({ type: 'setAll', rates: response });
                        return [2 /*return*/];
                }
            });
        }); })();
        return function () {
            canceled = true;
        };
    }, [getAll]);
    var handleSetExchangeRate = React.useCallback(function (newValue, oldValue, exchangeRates, columnDef) { return __awaiter(void 0, void 0, void 0, function () {
        var request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (newValue === oldValue || !columnDef.field)
                        return [2 /*return*/];
                    request = {
                        month: exchangeRates.month,
                        currency: columnDef.field,
                        rate: newValue,
                    };
                    return [4 /*yield*/, set(request)];
                case 1:
                    response = _a.sent();
                    if (!response)
                        return [2 /*return*/];
                    dispatch({ type: 'set', rate: response });
                    return [2 /*return*/];
            }
        });
    }); }, [set]);
    return (React.createElement(Wrapper, null,
        React.createElement(MaterialTable, { title: t('pages.exchangeRates.title'), model: "exchangeRate", emptyValue: "---", isLoading: loading, columns: columns, data: exchangeRates, cellEditable: {
                onCellEditApproved: handleSetExchangeRate,
                isCellEditable: function () { return true; },
            } })));
};
var exchangeRatesReducer = function (rates, action) {
    switch (action.type) {
        case 'setAll':
            return addLastAndCurrentMonthIfMissing(groupRatesByMonth(action.rates));
        case 'set': {
            var rate_1 = action.rate;
            return rates.map(function (rateForAllCurrencies) {
                var _a;
                if (rateForAllCurrencies.month === rate_1.month) {
                    return __assign(__assign({}, rateForAllCurrencies), (_a = {}, _a[rate_1.currency] = rate_1.rate, _a));
                }
                return rateForAllCurrencies;
            });
        }
    }
};
var groupRatesByMonth = function (exchangeRates) {
    var result = {};
    exchangeRates.forEach(function (rate) {
        var _a;
        result[_a = rate.month] || (result[_a] = {
            month: rate.month,
            JPY: '',
            EUR: '',
            KRW: '',
            TWD: '',
        });
        result[rate.month][rate.currency] = rate.rate;
    });
    return Object.values(result);
};
var addLastAndCurrentMonthIfMissing = function (exchangeRates) {
    var thisMonth = formatAsMonth(new Date());
    var lastMonth = formatAsMonth(addMonths(new Date(), -1));
    var result = __spreadArray([], exchangeRates, true);
    if (!result.find(function (rate) { return rate.month === thisMonth; })) {
        result.push({ month: thisMonth, JPY: '', EUR: '', KRW: '', TWD: '' });
    }
    if (!result.find(function (rate) { return rate.month === lastMonth; })) {
        result.push({ month: lastMonth, JPY: '', EUR: '', KRW: '', TWD: '' });
    }
    return result;
};
var formatAsMonth = function (date) { return format(date, 'yyyy-MM'); };
export default ExchangeRatesPage;
var templateObject_1;
